export const activeDirectoryForms = {
  activeDirectory: 'Active Directory',
  azureActiveDirectory: 'Azure Active Directory',
};

// eslint-disable-next-line no-shadow
export enum formActions {
  activate = 'activate',
  deactivate = 'deactivate',
}

export const protocolTypes = {
  ldap: 'ldap',
  ldaps: 'ldaps',
};
